import { defaultPhaseChangeLinesActionsTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  behaviorsReductionsData: null,  
  saved_defaultPhaseChangeLines: null,
  defaultPhaseChangelines: null,
  defaultPhaseChangelinesSettings: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case defaultPhaseChangeLinesActionsTypes.get_masterData.REQUEST:
      return {
        ...state,
        masterData: null,
      };
    case defaultPhaseChangeLinesActionsTypes.get_masterData.SUCCESS:
      return {
        ...state,
        masterData: payload,
      };  
    case defaultPhaseChangeLinesActionsTypes.get_BehaviorsReductionsData.REQUEST:
      return {
        ...state,
        loading: true,
        behaviorsReductionsData: null,
      };
    case defaultPhaseChangeLinesActionsTypes.get_BehaviorsReductionsData.SUCCESS:
      return {
        ...state,
        loading: false,
        behaviorsReductionsData: payload,
      };
    case defaultPhaseChangeLinesActionsTypes.get_TargetsAndProgramsData.REQUEST:
      return {
        ...state,
        loading: true,
        targetsAndProgramsData: null,
      };
    case defaultPhaseChangeLinesActionsTypes.get_TargetsAndProgramsData.SUCCESS:
      return {
        ...state,
        loading: false,
        targetsAndProgramsData: payload,
      };
    case defaultPhaseChangeLinesActionsTypes.save_DefaultPhaseChangeline.REQUEST:
      return {
        ...state,
        loading: true,
        saved_defaultPhaseChangeLines: null,
      };
    case defaultPhaseChangeLinesActionsTypes.save_DefaultPhaseChangeline.SUCCESS:
      return {
        ...state,
        loading: false,
        saved_defaultPhaseChangeLines: payload,
      };
    case defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesByPatientId.REQUEST:
      return {
        ...state,
        loading: true,
        defaultPhaseChangelines: null,
      };
    case defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesByPatientId.SUCCESS:
      return {
        ...state,
        loading: false,
        defaultPhaseChangelines: payload,
      };
      case defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesSettingsByPatientId.REQUEST:
        return {
          ...state,
          loading: true,
          defaultPhaseChangelinesSettings: null,
        };
      case defaultPhaseChangeLinesActionsTypes.get_DefaultPhaseChangelinesSettingsByPatientId.SUCCESS:
        return {
          ...state,
          loading: false,
          defaultPhaseChangelinesSettings: payload,
        };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/defaultPhaseChangeLines/reducers/DefaultPhaseChangeLinesReducer.js